import { render, staticRenderFns } from "./CandidateSliderItem.vue?vue&type=template&id=bc546586&scoped=true&"
import script from "./CandidateSliderItem.vue?vue&type=script&lang=js&"
export * from "./CandidateSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSliderItem.vue?vue&type=style&index=0&id=bc546586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc546586",
  null
  
)

/* custom blocks */
import block0 from "./CandidateSliderItem.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateSliderItem.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBadge,VHover,VIcon,VSheet})
